module.exports = __webpack_public_path__ + "img/matItem.77c58ca2.png";